import gql from 'graphql-tag';
import CLASSROOM_STATS_FRAGMENT from 'graph/fragments/classroom-stats';
import PRODUCT_FRAGMENT from 'graph/fragments/product';

const GET_CLASSROOM_STATS = gql`
  query getClassroomStats($id: Int!) {
    classroom(where: { id: $id }) {
      id
      name
      organization {
        id
        name
        type
      }
      licenseUsage {
        productId
        assignedCount
        product {
          ...BaseProduct
        }
      }
      stats {
        ...BaseClassroomStats
      }
    }
  }
  ${PRODUCT_FRAGMENT}
  ${CLASSROOM_STATS_FRAGMENT}
`;

export default GET_CLASSROOM_STATS;
